/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/trialos-study-team-member.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2026 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import AuditEnumValues from 'views/pages/admin/audit-log/definitions/enums';
import { getEnumChangeItem, getFieldChangeItems } from 'views/pages/admin/audit-log/service';

const TrialOsStudyTeamMemberRecordChangeGrid = ({ oldRecord, newRecord }: any) => {
    const enums: any = {
        RiskIQ: AuditEnumValues.RiskIQAccess,
    };

    const items = getFieldChangeItems(oldRecord, newRecord, null, (field: string) => {
        if (enums[field]) return [getEnumChangeItem(oldRecord, newRecord, field, enums[field])];
    });

    return <FieldChangeGrid items={items} />;
};

export { TrialOsStudyTeamMemberRecordChangeGrid };
